// 시스템 오류 모니터링 Phase 2 — 패널 표시 로직 (순수 함수, 2026-09-22).
// 컴포넌트에서 분리한 이유: "조회 실패(unavailable)"와 "이상 없음(0)"을 혼동하면 운영자가
// 장애를 정상으로 읽는다. 그 분기를 테스트로 고정한다(이 레포 테스트는 node 환경).

// data: undefined = 로딩 / null = 조회 실패 / object = 정상
export function panelState(data, loading) {
  if (data === undefined) return loading ? "loading" : "unavailable";
  if (data === null) return "unavailable";
  return "ready";
}

// ── Bedrock ─────────────────────────────────────────────────────────────────
// severity 는 NOVA 귀속(nova)만 본다. account/unattributed 는 타 프로젝트가 섞여 있어
// 절대 tone 을 올리지 않는다(backend severity 규칙과 동일).
export const BEDROCK_THRESH = { serverRatePct: 1, clientRatePct: 3 };

export function bedrockTone(nova) {
  const n = nova || {};
  const s = n.serverErrorRatePct;
  const c = n.clientErrorRatePct;
  if (s != null && s >= BEDROCK_THRESH.serverRatePct) return "critical";
  if ((c != null && c >= BEDROCK_THRESH.clientRatePct) || (n.throttles || 0) > 0) return "warn";
  return "ok";
}

export function bedrockSummary(nova) {
  const n = nova || {};
  if (!n.invocations) return "NOVA 호출 없음";
  return `서버 ${n.serverErrorRatePct ?? 0}% · 요청 ${n.clientErrorRatePct ?? 0}%`;
}

// ── DynamoDB ────────────────────────────────────────────────────────────────
export function ddbTone(data) {
  return (data?.totalThrottled || 0) > 0 ? "critical" : "ok";
}

export function ddbSummary(data) {
  const t = data?.totalThrottled || 0;
  return t === 0 ? "이상 없음" : `${t}건`;
}

// ── 실제 Lambda Timeout ─────────────────────────────────────────────────────
// 계측 미설정(configured=false)을 "0건"으로 표시하지 않는다 — 계측 공백을 정상으로
// 오인하면 실제 timeout 을 놓친다.
export function timeoutTone(data) {
  if (!data) return "na";
  const fns = data.functions || [];
  const notCfg = data.notConfigured || [];
  if ((data.total || 0) > 0) return "critical";
  if (fns.length > 0 && notCfg.length === fns.length) return "na";
  if (notCfg.length > 0) return "warn";
  return "ok";
}

export function timeoutSummary(data) {
  if (!data) return "조회 실패";
  const fns = data.functions || [];
  const notCfg = data.notConfigured || [];
  const total = data.total || 0;
  if (total > 0) return `${total}건`;
  if (fns.length > 0 && notCfg.length === fns.length) return "계측 미설정";
  if (notCfg.length > 0) return `이상 없음 · 일부 미계측 ${notCfg.length}`;
  return "이상 없음";
}
